import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "employee-letters"
    }}>{`Employee Letters`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Businesses generate employee letters for various formal communications, like compensation changes, awards letters, and performance reviews. Many of these letters need to include data stored in the HR system. For large organizations, creating custom letters manually for every employee becomes a time-consuming task.`}</p>
    <p>{`Adobe Acrobat Services allows organizations to:`}</p>
    <ul>
      <li parentName="ul">{`Create standard branded templates for employee letters`}</li>
      <li parentName="ul">{`Merge employee data automatically into templates`}</li>
      <li parentName="ul">{`Protect documents from editing with a password`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/doc-generation.md"
        }}>{`Adobe Document Generation API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`The HR team in charge of employee compensation needs to send letters formally communicating changes to the employee awards policy. Each letter should outline the individual impact for each employee. Data on each employee’s awards is stored in their HR system, and over one thousand letters need to be generated for employees before the next pay period.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <ol>
      <li parentName="ol">{`Create a simple data capture form using Microsoft Form (or another form builder)`}</li>
      <li parentName="ol">{`Design the letter template using Microsoft Word`}</li>
      <li parentName="ol">{`Use Adobe Document Generation Tagger in Word to place fields into the template based on the data model from the form`}</li>
      <li parentName="ol">{`Run the Adobe Document Generation API to merge data from the form into the template, creating a final letter in PDF`}</li>
      <li parentName="ol">{`Use Adobe PDF Services API to protect the document from editing`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      